var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.printMode)?_c('span',{staticClass:"showText"},[_vm._v(_vm._s(_vm.value2))]):_c('el-input',{attrs:{"size":_vm.size,"value":_vm.value2,"readonly":"readonly"}})
}
var staticRenderFns = []

export { render, staticRenderFns }